import {Component, ElementRef, Input, OnChanges, OnInit, Renderer2} from "@angular/core";
import {HostingService} from "../../website/hosting/hosting.service";

import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable} from 'rxjs';
import {filter, first, switchMap} from 'rxjs/operators';
import {ActivityStatus, IActivity} from "../../../activities/activity";
import {GoogleAnalyticsService} from "../../../shared/services/google-analytics/google-analytics.service";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {Router} from "@angular/router";
import {RouteDataService} from "../../../shared/services/route-data/route-data.service";
import {TextUtils} from "../../../shared/utils/text-utils";

@Component({
    selector: 'db-website-install-loading-dialog',
    templateUrl: 'website-install-loading-dialog.component.html',
    styleUrls: ['website-install-loading-dialog.component.scss'],
    standalone: false
})
export class WebsiteInstallLoadingDialogComponent implements OnInit, OnChanges {
  public loading: boolean;
  public loadingContent: boolean;
  public ongoingActivity$: Observable<IActivity>;
  public step1: any;
  public step2: any;
  @Input() step3: any;
  @Input() insidePageContent?: any;
  @Input() insidePageStatic?: any;
  public timeForThirdStep: number;
  public isMobile: boolean;
  public steps: any;
  public activity: any;
  public companyName: string = 'Dashboard';
  public loadingTitle: string = '';

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _hostingService: HostingService,
    private el: ElementRef,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _dialogService: DialogService,
    private _router: Router,
    private renderer: Renderer2,
    private _routeDataService: RouteDataService,
) {
  }


  ngOnInit () {
    this._getCompanyInfo();
    if (window.innerWidth < 991) {
      this.isMobile = true;
    }
    this.timeForThirdStep = 5200;
    this.steps = ['text_loadingStep1', 'text_loadingStep2', 'text_loadingStep3'];
    this.step1 = this.step3 === 'done' ? 'done' : 'loading';
    this.ongoingActivity$ = this._store.select(fromStore.getCreateWebsiteOngoingActivity);
    this.ongoingActivity$.subscribe((activity) => {
      if (activity && activity !== null) {
        this.activity = activity;
        this.checkActivityStatus();
      }
    });
    this.checkActivityStatus();
  }

  ngOnChanges(changes: any) {
    this.step3 = changes.step3.currentValue;
    if (this.step3 === 'done') {
      this.step1 = this.step2 = 'done';
    }
  }

  public checkActivityStatus(): void {
    if (this.activity && this.activity.status === ActivityStatus.DONE) {
      this.step1 = this.step2 = this.step3 = 'done';
    }
    else {
      if (this.step1 !== 'done') {
        setTimeout( () => {
          if (this.activity) {
            this.timeForThirdStep = 31000;
            setTimeout( () => {
              this.loadingSteps();
            }, 23200 ); // 28000
          }
          else {
            this.loadingSteps();
          }
        }, 4800);
      }
    }
  }

  public loadingSteps() {
      if (this.step2 !== 'done') {
        this.fadeEl();
        this.step1 = 'done';
        this.step2 = 'loading';
        setTimeout(() => {
          this.fadeEl();
          this.step2 = 'done';
          this.step3 = 'loading';
        }, this.timeForThirdStep);
      }
  }
  public fadeEl(): void {
    const loadingImg = document.getElementById('loadingImg');

    this.renderer && this.renderer.addClass(loadingImg, 'fadeout');

    setTimeout(() => {
      this.renderer && this.renderer.removeClass(loadingImg, 'fadeout');

      this.renderer && this.renderer.addClass(loadingImg, 'fade');

      setTimeout(() => {
        this.renderer && this.renderer.removeClass(loadingImg, 'fade');
      }, 250);
    }, 250);
  }

  private _getCompanyInfo(): void {
    this._store.select(fromStore.getCompanyInfoLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getCompanyInfo)),
        first()
      )
      .subscribe((companyInfo: any) => {
        this.companyName = companyInfo?.branding?.company_name || companyInfo?.agency?.name || 'YourBrand';
        this.loadingTitle = TextUtils.getText('text_blankWordPressInstalling', {companyName: this.companyName});
      });
  }

}

